export const PACKAGE_NAME = 'jiraRouterResourcesGrowthRecommendations';
